import { useQuery } from 'react-query';
import axios from 'axios';
import config from '../config';
import useSearchState from "./useSearch";

export const getCacheKeyForSchool = (address, radius = 2500) => `schools_${encodeURIComponent(address?.lat)}_${encodeURIComponent(address?.lng)}_${encodeURIComponent(radius)}`;

const useSchoolsData = (location, radius = 2500) => {
  const {searchState} = useSearchState()
  const savedSearchId = searchState?.savedSearchId
  const cacheKey = getCacheKeyForSchool(location, radius)
  const currentCacheKey = ["schoolsData", cacheKey, savedSearchId];
  const enabled = Boolean(location && location.lat && location.lng) && (savedSearchId === null);

  return useQuery(
    //['schoolsData', location, radius],
    currentCacheKey,
    async () => {
      const response = await axios.get(`${config.apiUrl}/schools/google`, {
        params: {
          lat: location.lat,
          lng: location.lng,
          radius,
        },
      });
      return response.data.schools || [];
    },
    {
      //enabled: Boolean(location && location.lat && location.lng),
      enabled,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMouseEnter: false,
    },
  );
};

export default useSchoolsData;
